import { Input, Select } from "antd";
import React, { createRef, useState, useEffect } from "react";
import AddButton from "../../../../Componets/Buttons/add";
import { select_search } from "../../../../Controllers/Global";
import toast from "react-hot-toast";
import { DeleteOutlined } from "@ant-design/icons";
import Error from "../../../../Componets/Error";
import { get_product_unit } from "../../../../Controllers/Products/Units";
import Required from "../../../../Componets/Required";
import { formatDecimal6 } from "../../../../Main/formatDecimal";

const Inventoryunittable = React.forwardRef((props, focus) => {
  const { details, setDetails, form, setForm } = props;

  const [batchPrices, setBatchPrices] = useState({
    purchase_price: 0,
    price_per_unit: 0,
    sale_price: 0,
    wholesale_price: 0
  });

  useEffect(() => {
    if (form && Array.isArray(form)) {
      const pricingSection = form.find(section => section.name === "Pricing");
      if (pricingSection && pricingSection.options) {
        const newBatchPrices = {
          purchase_price: 0,
          price_per_unit: 0,
          sale_price: 0,
          wholesale_price: 0
        };

        pricingSection.options.forEach(option => {
          switch (option.form?.name) {
            case 'purchase_price':
              newBatchPrices.purchase_price = parseFloat(option.form?.value) || 0;
              break;
            case 'price_per_unit':
              newBatchPrices.price_per_unit = parseFloat(option.form?.value) || 0;
              break;
            case 'sale_price':
              newBatchPrices.sale_price = parseFloat(option.form?.value) || 0;
              break;
            case 'wholesale_price':
              newBatchPrices.wholesale_price = parseFloat(option.form?.value) || 0;
              break;
          }
        });

        setBatchPrices(newBatchPrices);

        recalculateUnitPrices(newBatchPrices);
      }
    }
  }, [form]);

  const calculateUnitPrice = (batchPrice, conversion) => {
    if (!batchPrice || !conversion || conversion <= 0) return 0;
    return (batchPrice / conversion).toFixed(2);
  };

  const recalculateUnitPrices = (prices = batchPrices) => {
    let data = [...details];

    data = data.map(item => {
      const conversion = parseFloat(item.conversion) || 0;

      if (conversion > 0) {
        return {
          ...item,
          purchase_price: calculateUnitPrice(prices.purchase_price, conversion),
          price_per_unit: calculateUnitPrice(prices.price_per_unit, conversion),
          sale_price: calculateUnitPrice(prices.sale_price, conversion),
          wholesale_price: calculateUnitPrice(prices.wholesale_price, conversion)
        };
      }
      return item;
    });

    setDetails(data);
  };

  const handleChange = (e, index) => {

    let value = parseFloat(e?.target?.value);

    if (value) {
      value = formatDecimal6(value);
    }

    if (value >= 0) {
      let data = [...details];
      const fieldName = e?.target?.name;

      data[index][fieldName] = value;


      if (fieldName === "conversion" && value > 0) {
        data[index].purchase_price = calculateUnitPrice(batchPrices.purchase_price, value);
        data[index].price_per_unit = calculateUnitPrice(batchPrices.price_per_unit, value);
        data[index].sale_price = calculateUnitPrice(batchPrices.sale_price, value);
        data[index].wholesale_price = calculateUnitPrice(batchPrices.wholesale_price, value);
      }

      setDetails(data);

      if (fieldName === "stock" && details?.[0]?.conversion) {
        const stockValue = parseFloat(e?.target?.value || 0);
        const conversion = parseFloat(details?.[0]?.conversion || 0);

        if (stockValue > 0 && conversion > 0) {
          let updatedForm = [...form];
          const stockSectionIndex = updatedForm.findIndex(section => section.name === "Stock");

          if (stockSectionIndex !== -1 && updatedForm[stockSectionIndex]?.options?.[0]) {
            const totalBatchStock = (stockValue / conversion);
            updatedForm[stockSectionIndex].options[0].form.value = totalBatchStock;
            setForm(updatedForm);
          }
        }
      }
    }
  };

  const handleAdd = () => {
    setDetails((prevDetails) => [
      ...prevDetails,
      {
        id: "",
        name: null,
        label: "",
        options: "",
        conversion: "",
        purchase_price: "",
        price_per_unit: "",
        sale_price: "",
        wholesale_price: "",
        stock: ""
      },
    ]);
  };

  const handleRemove = (index) => {
    let data = [...details];

    data?.splice(index, 1);

    setDetails(data);
  };

  const handleSearch = async (e, index) => {
    let data = [...details];

    const select = {
      api: "get-all-product-units",
      search: e,
      status: 1,
    };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];
      search?.data?.data?.map((value, index) => {
        options?.push({ value: value?._id, label: value?.name });
        // options?.push({ value: value?.name, label: value?.name });
      });

      data[index].options = options;

      setDetails(data);
    } else {
      toast?.error(search?.message);
    }
  };

  const handleConversion = (e, index) => {
    let value = parseFloat(e?.target?.value);

    if (value) {
      value = formatDecimal6(value);
    }

    if (value >= 0) {
      let data = [...details];
      data[index][e?.target?.name] = value;

      if (value > 0) {
        data[index].purchase_price = calculateUnitPrice(batchPrices.purchase_price, value);
        data[index].price_per_unit = calculateUnitPrice(batchPrices.price_per_unit, value);
        data[index].sale_price = calculateUnitPrice(batchPrices.sale_price, value);
        data[index].wholesale_price = calculateUnitPrice(batchPrices.wholesale_price, value);
      } else {
        data[index].purchase_price = "";
        data[index].price_per_unit = "";
        data[index].sale_price = "";
        data[index].wholesale_price = "";
      }

      setDetails(data);
    }
  };

  const handleName = async (e, index) => {
    let data = [...details];

    if (e) {
      let ids = [];

      data?.map((v, i) => {
        ids?.push(v?.name);
      });

      if (!ids?.includes(e)) {
        let params = {
          id: e,
        };

        const product_unit = await get_product_unit(params);

        // data[index].name = product_unit?.data?._id;
        data[index].name = product_unit?.data?.name;
        data[index].label = product_unit?.data?.name;

        if (data[index].conversion) {
          const conversion = parseFloat(data[index].conversion);
          data[index].purchase_price = calculateUnitPrice(batchPrices.purchase_price, conversion);
          data[index].price_per_unit = calculateUnitPrice(batchPrices.price_per_unit, conversion);
          data[index].sale_price = calculateUnitPrice(batchPrices.sale_price, conversion);
          data[index].wholesale_price = calculateUnitPrice(batchPrices.wholesale_price, conversion);
        }
        setDetails(data);
      } else {
        data[index].name = null;
        data[index].label = "";
        setDetails(data);
        toast?.error("Unit exists");
      }
    } else {
      data[index].name = null;
      data[index].label = "";
      data[index].conversion = "";
      data[index].purchase_price = "";
      data[index].price_per_unit = "";
      data[index].sale_price = "";
      data[index].wholesale_price = "";
      data[index].stock = "";
      setDetails(data);
    }
  };

  return (
    <div>
      <table className="w-full">
        <thead>
          <tr>
            <td className="border p-4 text-black">
              Name
              <Required />
            </td>
            <td className="border p-4 text-black">
              Conversion <Required />
            </td>
            <td className="border p-4 text-black">
              Purchase price <Required />
              <span className="text-xs text-gray-500 block">
                Batch: {batchPrices.purchase_price.toFixed(3)}
              </span>
            </td>
            <td className="border p-4 text-black">
              Price/unit <Required />
              <span className="text-xs text-gray-500 block">
                Batch: {batchPrices.price_per_unit.toFixed(3)}
              </span>
            </td>
            <td className="border p-4 text-black">
              Sale price <Required />
              <span className="text-xs text-gray-500 block">
                Batch: {batchPrices.sale_price.toFixed(3)}
              </span>
            </td>
            <td className="border p-4 text-black">
              Wholesale price
              <span className="text-xs text-gray-500 block">
                Batch: {batchPrices.wholesale_price.toFixed(3)}
              </span>
            </td>
            <td className="border p-4 text-black">
              Stock <Required />
            </td>
            <td className="border p-4 text-black">Delete</td>
          </tr>
        </thead>
        <tbody>
          {details?.map((value, index) => {
            // focus.current[`name${index}`] = createRef();
            // focus.current[`conversion${index}`] = createRef();
            return (
              <React.Fragment>
                <tr>
                  {/* <td className="border p-4 text-left">{value?.name}</td> */}
                  <td className="border p-4">
                    {value?.name ? (
                      <div>
                        <div> {value?.name}</div>
                        <Error id={`name${index}`} />
                      </div>
                    ) : (
                      <div>
                        <Select
                          key={index}
                          name="name"
                          // ref={focus.current[`name${index}`]}
                          className="w-[150px] text-regular"
                          placeholder="Name"
                          allowClear={true}
                          showSearch={true}
                          filterOption={false}
                          options={value?.options}
                          value={value?.name}
                          onSearch={(e) => handleSearch(e, index)}
                          onClick={(e) => handleSearch("", index)}
                          onChange={(e) => handleName(e, index)}
                          autoComplete="off"
                        />
                        <Error id={`name${index}`} />
                      </div>
                    )}
                  </td>
                  {/* <td className="border p-4">{value?.conversion}</td> */}
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="conversion"
                      // ref={focus.current[`conversion${index}`]}
                      type="number"
                      className="w-full text-regular"
                      placeholder="Conversion"
                      value={value?.conversion}
                      onChange={(e) => handleConversion(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                    <Error id={`conversion${index}`} />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="purchase_price"
                      type="number"
                      className="w-full text-regular"
                      placeholder="Purchase price"
                      value={value?.purchase_price}
                      /* onChange={(e) => handleChange(e, index)} */
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="price_per_unit"
                      type="number"
                      className="w-full text-regular"
                      placeholder="Price/unit"
                      value={value?.price_per_unit}
                      /* onChange={(e) => handleChange(e, index)} */
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="sale_price"
                      type="number"
                      className="w-full text-regular"
                      placeholder="Sale price"
                      value={value?.sale_price}
                      /* onChange={(e) => handleChange(e, index)} */
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="wholesale_price"
                      type="number"
                      className="w-full text-regular"
                      placeholder="WholeSale price"
                      value={value?.wholesale_price}
                      /* onChange={(e) => handleChange(e, index)} */
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                  </td>
                  <td className="border p-4">
                    <Input
                      key={index}
                      name="stock"
                      type="number"
                      className="w-full text-regular"
                      placeholder="Stock"
                      value={value?.stock}
                      onChange={(e) => handleChange(e, index)}
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                    <Error id={`stock${index}`} />
                  </td>
                  <td className="border p-4 text-center">
                    <button
                      type="button"
                      className="text-lg text-red-500 cursor-pointer hover:text-red-800"
                      onClick={() => handleRemove(index)}
                    >
                      <DeleteOutlined />
                    </button>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
          {details?.length < 1 ? (
            <tr>
              <td className="border p-4" colSpan={8}>
                <div className="text-end">
                  <AddButton onClick={handleAdd} />
                </div>
              </td>
            </tr>
          ) : (
            ""
          )}
        </tbody>
      </table>
    </div>
  );
});

export default Inventoryunittable;
